import { SavedView } from "../types";

export const elec : SavedView = {
    name: "elec",
    state: {
        "sideBar": {
            "position": "right",
            "visible": false,
            "openToolPanel": null,
            "toolPanels": {}
        },
        "sort": {
            "sortModel": [
                {
                    "colId": "account_name",
                    "sort": "asc"
                },
                {
                    "colId": "site_group",
                    "sort": "asc"
                },
                {
                    "colId": "site_address",
                    "sort": "asc"
                },
                {
                    "colId": "supply_type",
                    "sort": "asc"
                },
                {
                    "colId": "supply_subtype",
                    "sort": "asc"
                },
                {
                    "colId": "supply_verbose",
                    "sort": "asc"
                }
            ]
        },
        "rowGroup": {
            "groupColIds": [
                "account_name",
                "site_group",
                "site_address"
            ]
        },
        "columnVisibility": {
            "hiddenColIds": [
                "account_name",
                "site_group",
                "site_address",
                "supply_number",
                "ooc",
                "eb_meterserialnumber"
            ]
        },
        "columnSizing": {
            "columnSizingModel": [
                {
                    "colId": "account_name",
                    "width": 200
                },
                {
                    "colId": "site_group",
                    "width": 200
                },
                {
                    "colId": "site_address",
                    "width": 200
                },
                {
                    "colId": "supply_type",
                    "width": 200
                },
                {
                    "colId": "supply_subtype",
                    "width": 200
                },
                {
                    "colId": "supply_verbose",
                    "width": 300
                },
                {
                    "colId": "supply_supplier",
                    "width": 200
                },
                {
                    "colId": "contract_end_date",
                    "width": 200
                },
                {
                    "colId": "eb_currentconsumption",
                    "width": 200
                },
                {
                    "colId": "supply_number",
                    "width": 200
                },
                {
                    "colId": "ooc",
                    "width": 200
                },
                {
                    "colId": "eb_meterserialnumber",
                    "width": 200
                }
            ]
        },
        "columnOrder": {
            "orderedColIds": [
                "account_name",
                "site_group",
                "site_address",
                "supply_type",
                "supply_subtype",
                "supply_verbose",
                "supply_supplier",
                "contract_end_date",
                "eb_currentconsumption",
                "supply_number",
                "ooc",
                "eb_meterserialnumber"
            ]
        },
        "filter": {
            "filterModel": {
                "supply_type": {
                    "filterType": "multi",
                    "filterModels": [
                        null,
                        {
                            "values": [
                                "Electricity"
                            ],
                            "filterType": "set"
                        }
                    ]
                }
            }
        },
        "pagination": {
            "page": 0,
            "pageSize": 100
        }
    }
}

export const gas: SavedView = {
    name: "gas",
    state: {
        "sideBar": {
            "position": "right",
            "visible": false,
            "openToolPanel": null,
            "toolPanels": {}
        },
        "sort": {
            "sortModel": [
                {
                    "colId": "account_name",
                    "sort": "asc"
                },
                {
                    "colId": "site_group",
                    "sort": "asc"
                },
                {
                    "colId": "site_address",
                    "sort": "asc"
                },
                {
                    "colId": "supply_type",
                    "sort": "asc"
                },
                {
                    "colId": "supply_subtype",
                    "sort": "asc"
                },
                {
                    "colId": "supply_verbose",
                    "sort": "asc"
                }
            ]
        },
        "rowGroup": {
            "groupColIds": [
                "account_name",
                "site_group",
                "site_address"
            ]
        },
        "columnVisibility": {
            "hiddenColIds": [
                "account_name",
                "site_group",
                "site_address",
                "supply_number",
                "ooc",
                "eb_meterserialnumber"
            ]
        },
        "columnSizing": {
            "columnSizingModel": [
                {
                    "colId": "account_name",
                    "width": 200
                },
                {
                    "colId": "site_group",
                    "width": 200
                },
                {
                    "colId": "site_address",
                    "width": 200
                },
                {
                    "colId": "supply_type",
                    "width": 200
                },
                {
                    "colId": "supply_subtype",
                    "width": 200
                },
                {
                    "colId": "supply_verbose",
                    "width": 300
                },
                {
                    "colId": "supply_supplier",
                    "width": 200
                },
                {
                    "colId": "contract_end_date",
                    "width": 200
                },
                {
                    "colId": "eb_currentconsumption",
                    "width": 200
                },
                {
                    "colId": "supply_number",
                    "width": 200
                },
                {
                    "colId": "ooc",
                    "width": 200
                },
                {
                    "colId": "eb_meterserialnumber",
                    "width": 200
                }
            ]
        },
        "columnOrder": {
            "orderedColIds": [
                "account_name",
                "site_group",
                "site_address",
                "supply_type",
                "supply_subtype",
                "supply_verbose",
                "supply_supplier",
                "contract_end_date",
                "eb_currentconsumption",
                "supply_number",
                "ooc",
                "eb_meterserialnumber"
            ]
        },
        "filter": {
            "filterModel": {
                "supply_type": {
                    "filterType": "multi",
                    "filterModels": [
                        null,
                        {
                            "values": [
                                "Gas"
                            ],
                            "filterType": "set"
                        }
                    ]
                }
            }
        },
        "pagination": {
            "page": 0,
            "pageSize": 100
        }
    }
}

export const water: SavedView = {
    name: "water",
    state: {
        "sideBar": {
            "position": "right",
            "visible": false,
            "openToolPanel": null,
            "toolPanels": {}
        },
        "sort": {
            "sortModel": [
                {
                    "colId": "account_name",
                    "sort": "asc"
                },
                {
                    "colId": "site_group",
                    "sort": "asc"
                },
                {
                    "colId": "site_address",
                    "sort": "asc"
                },
                {
                    "colId": "supply_type",
                    "sort": "asc"
                },
                {
                    "colId": "supply_subtype",
                    "sort": "asc"
                },
                {
                    "colId": "supply_verbose",
                    "sort": "asc"
                }
            ]
        },
        "rowGroup": {
            "groupColIds": [
                "account_name",
                "site_group",
                "site_address"
            ]
        },
        "columnVisibility": {
            "hiddenColIds": [
                "account_name",
                "site_group",
                "site_address",
                "supply_number",
                "ooc",
                "eb_meterserialnumber"
            ]
        },
        "columnSizing": {
            "columnSizingModel": [
                {
                    "colId": "account_name",
                    "width": 200
                },
                {
                    "colId": "site_group",
                    "width": 200
                },
                {
                    "colId": "site_address",
                    "width": 200
                },
                {
                    "colId": "supply_type",
                    "width": 200
                },
                {
                    "colId": "supply_subtype",
                    "width": 200
                },
                {
                    "colId": "supply_verbose",
                    "width": 300
                },
                {
                    "colId": "supply_supplier",
                    "width": 200
                },
                {
                    "colId": "contract_end_date",
                    "width": 200
                },
                {
                    "colId": "eb_currentconsumption",
                    "width": 200
                },
                {
                    "colId": "supply_number",
                    "width": 200
                },
                {
                    "colId": "ooc",
                    "width": 200
                },
                {
                    "colId": "eb_meterserialnumber",
                    "width": 200
                }
            ]
        },
        "columnOrder": {
            "orderedColIds": [
                "account_name",
                "site_group",
                "site_address",
                "supply_type",
                "supply_subtype",
                "supply_verbose",
                "supply_supplier",
                "contract_end_date",
                "eb_currentconsumption",
                "supply_number",
                "ooc",
                "eb_meterserialnumber"
            ]
        },
        "filter": {
            "filterModel": {
                "supply_type": {
                    "filterType": "multi",
                    "filterModels": [
                        null,
                        {
                            "values": [
                                "Water"
                            ],
                            "filterType": "set"
                        }
                    ]
                }
            }
        },
        "pagination": {
            "page": 0,
            "pageSize": 100
        }
    }
}

export const invoices_by_month: SavedView = {
    name: "Invoices by Month",
    state: {
        sort: {
            sortModel: [
                { colId: "invoice_month", sort: "desc" },
                { colId: "account_name", sort: "asc" },
                { colId: "supply_number", sort: "asc" },
                { colId: "period_start", sort: "asc" },
                { colId: "period_end", sort: "asc" },
                { colId: "invoice_date", sort: "asc"}
            ]
        },
        rowGroup: {
            groupColIds: ["invoice_month", "account_name"]
        },
        columnPinning: {
            leftColIds: ["filehash", "invoice_date", "supply_number", "invoice_number"],
            rightColIds: []
        },
        columnVisibility: {
            hiddenColIds: ["invoice_month", "account_name"]
        },
        columnSizing: {
            columnSizingModel: [
                { colId: "invoice_month", width: 200 },
                { colId: "account_name", width: 200 },
                { colId: "filehash", width: 110 },
                { colId: "invoice_date", width: 130 },
                { colId: "supply_number", width: 170 },
                { colId: "invoice_number", width: 150 },
                { colId: "supply_type_code", width: 100 },
                { colId: "period_start", width: 130 },
                { colId: "period_end", width: 130 },
                { colId: "supplier_code", width: 110 },
                { colId: "subtotal", width: 110 },
                { colId: "bill_total", width: 130 },
                { colId: "supply_consumption", width: 145 },
                { colId: "standing", width: 130 },
                { colId: "supply_delivery", width: 130 },
                { colId: "metering", width: 130 },
                { colId: "levy", width: 130 },
                { colId: "finance", width: 130 },
                { colId: "validation", width: 120 },
                { colId: "message", width: 150 }
            ]
        },
        columnOrder: {
            orderedColIds: [
                "invoice_month",
                "account_name",
                "filehash",
                "invoice_date",
                "supply_number",
                "invoice_number",
                "supply_type_code",
                "period_start",
                "period_end",
                "supplier_code",
                "bill_total",
                "subtotal",
                "supply_consumption",
                "standing",
                "supply_delivery",
                "metering",
                "levy",
                "finance",
                "validation",
                "message"
            ]
        }
    }
};

export const invoices_by_supply: SavedView = {
    name: "Invoices by Supply",
    state: {
        sort: {
            sortModel: [
                { colId: "account_name", sort: "asc" },
                { colId: "supply_number", sort: "asc" },
                { colId: "invoice_date", sort: "asc" }
            ]
        },
        rowGroup: {
            groupColIds: ["account_name", "supply_number"]
        },
        columnPinning: {
            leftColIds: ["filehash", "invoice_date", "supply_number", "invoice_number"],
            rightColIds: []
        },
        columnVisibility: {
            hiddenColIds: ["invoice_month", "account_name", "supply_number"]
        },
        columnSizing: {
            columnSizingModel: [
                { colId: "invoice_month", width: 200 },
                { colId: "account_name", width: 200 },
                { colId: "filehash", width: 110 },
                { colId: "invoice_date", width: 130 },
                { colId: "supply_number", width: 170 },
                { colId: "invoice_number", width: 150 },
                { colId: "supply_type_code", width: 100 },
                { colId: "period_start", width: 130 },
                { colId: "period_end", width: 130 },
                { colId: "supplier_code", width: 110 },
                { colId: "subtotal_w_vat", width: 140 },
                { colId: "supply_consumption", width: 145 },
                { colId: "standing", width: 130 },
                { colId: "supply_delivery", width: 130 },
                { colId: "metering", width: 130 },
                { colId: "levy", width: 130 },
                { colId: "finance", width: 130 },
                { colId: "vat_total", width: 130 },
                { colId: "bill_total", width: 140 },
                { colId: "validation", width: 120 },
                { colId: "message", width: 150 }
            ]
        },
        columnOrder: {
            orderedColIds: [
                "invoice_month",
                "account_name",
                "filehash",
                "invoice_date",
                "supply_number",
                "invoice_number",
                "supply_type_code",
                "period_start",
                "period_end",
                "supplier_code",
                "subtotal_w_vat",
                "supply_consumption",
                "standing",
                "supply_delivery",
                "metering",
                "levy",
                "finance",
                "vat_total",
                "bill_total",
                "validation",
                "message"
            ]
        }
    }
}

export const siteSummaryDefaults : SavedView[] = [elec, gas, water];

export const invoicesDefaults : SavedView[] = [invoices_by_month, invoices_by_supply];
